<script>
//utils
import singleEliminationRoundHelper from '@/views/tournaments/management/brackets/single-elimination/mixins/roundHelper';
//components
import Table from '@/views/tournaments/management/brackets/components/TableView';
export default {
  name: 'TournamentSingleEliminationTableView',
  functional: true,
  props: {
    roundID: {
      type: [Number, String],
      default: 0,
    },
  },
  render(h, context) {
    return h(Table, {
      props: {
        roundName: singleEliminationRoundHelper.methods.roundName,
        roundID: context.props.roundID,
      },
      on: context.listeners,
    });
  },
};
</script>
